import { Logo } from '@assets/icons'
import { Loading, ServerError } from '@components'
import { useWithAmpli } from '@contexts/AmpliContextProvider'
import { useEnvConfig } from '@contexts/EnvConfigProvider'
import { useOwnOrganisation } from '@hooks/useOwnOrganisation'
import { Menu } from '@router/Menu'
import * as S from '@router/styles'
import { AuthContext } from 'contexts/AuthContextProvider'
import { FC, useContext, useEffect } from 'react'
import { Outlet } from 'react-router-dom'

export const SecureZone: FC = () => {
	const authContext = useContext(AuthContext)

	const { data, isLoading, error } = useOwnOrganisation()

	const envConfig = useEnvConfig()
	const withAmpli = useWithAmpli()
	useEffect(() => {
		if (data?.data?.id && !error && !isLoading) {
			withAmpli(ampli =>
				ampli.identify(authContext.user.id, {
					// @ts-expect-error
					organisationId: data.data.id,
					organisationName: data.data.name,
				})
			)
		}
	}, [authContext.user.id, data, envConfig, error, isLoading, withAmpli])

	if (isLoading) {
		return <Loading noWrapper={false} containerHeight="100vh" />
	}

	if (!data?.data || error) {
		return <ServerError />
	}

	// TODO(pascal): Use co2AiCorpoUrl back for orgs that have a corp account when we have some.

	return (
		<S.Root>
			<Menu />
			<S.Content>
				<S.LogoWrapper>
					<Logo width={200} height={25} />
				</S.LogoWrapper>
				<Outlet />
			</S.Content>
		</S.Root>
	)
}
